import { isPlainObject } from 'lodash';

import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

const getSalons = nullBind(getAnyOrNull, 'lib.supportSalons');

const selectSupportedSalons = (state) => {
  const salons = getSalons(state);

  if (!isPlainObject(salons)) {
    return null;
  }

  return salons || null;
};

export default selectSupportedSalons;
